/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import Alert from 'react-s-alert';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import GeneralService from '../../services/GeneralService';
import ClientService from '../../services/ClientService';
import ProviderService from '../../services/ProviderService';

// local imports
import ProviderNavbar from '../provider/ProviderNavbar';
import ClientNavbar from '../client/ClientNavbar';
import OrganisationNavbar from '../organisation/OrganisationNavbar';
import Logo from '../../assets/UW_Horizontal_Logo_Full.png'


const GeneralNavbar = (props) => {

    // states
    const [isOpenProfileDropdown, setIsOpenProfileDropdown] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    // contexts
    const { theme, fontFamily } = useContext(ThemeContext);
    const { user, setUser, isAuthenticated, maintenance, NEXT_APP_URL } = useContext(AuthContext);

    // utility functions
    const toggle = () => setIsOpen(!isOpen);

    const toggleProfileDropdown = () => setIsOpenProfileDropdown(!isOpenProfileDropdown);

    // useEffects
    useEffect(() => {
        if (user.selectedRole === "client") {
            ClientService.getClientProfileImage()
                .then(data => {
                    try {
                        // setProfileImage(data.profileImage);
                        setUser({ ...user, profileImage: data.profileImage });
                    } catch (err) {
                        Alert.error("Some error occured, please try again later or report support team.", {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        GeneralService.logError('at General GeneralNavbar useEffect', 'Error in try catch block', err.stack);
                    }
                })
        } else if (user.selectedRole === "provider") {
            ProviderService.getProviderProfileImageAndEmail()
                .then(data => {
                    try {
                        //setProfileImage(data.profileImage);
                        setUser({ ...user, profileImage: data.profileImage });
                    } catch (err) {
                        Alert.error("Some error occured, please try again later or report support team.", {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        GeneralService.logError('at General GeneralNavbar useEffect', 'Error in try catch block', err.stack);
                    }
                })
        }
    }, [])

  return (
    isAuthenticated ?
            user.selectedRole === "client" ?
                <ClientNavbar history={props.history} isHome={true} />
                :
                user.selectedRole === "provider" ?
                    <ProviderNavbar history={props.history} isHome={true} />
                    :
                    user.selectedRole === "organisation_admin" ?
                        <OrganisationNavbar history={props.history} isHome={true} />
                        :
                        <div>
                            {maintenance.status ? <div className="alert alert-primary marquee" style={{ margin: "0 -15px" }}><div>Umang Wellness is going to conduct maintenace to improve your experience. It will go under maintenance on {moment(maintenance.startAt).format("DD-MM-YYYY [at] hh:mm A")} for {maintenance.duration} minutes. During these time you won't be able to use Umang Wellness.</div></div> : null}
                            <Navbar id="general-navbar" color="white" light expand="md" style={{ fontFamily: fontFamily.primary, padding: '0.5rem 0' }}>
                                <NavbarBrand id="brand-logo" href={NEXT_APP_URL}>
                                    <img style={{ maxWidth: "160px", height: "auto", border: "none", margin: "0" }} src={Logo} alt="Umang Logo" />
                                </NavbarBrand>
                                <NavbarToggler onClick={toggle} />
                                <Collapse isOpen={isOpen} navbar>
                                    <Nav className="ml-auto" navbar>
                                        {
                                            props.isDemoPage ? null :
                                                <NavItem>
                                                    <NavLink id="demo-login-nav-item" href="/demo/signin" style={theme.navbarItem} >Demo</NavLink>
                                                </NavItem>
                                        }
                                        {
                                            props.isAboutPage ? null :
                                                <NavItem>
                                                    <NavLink id="about-nav-item" href={NEXT_APP_URL + "/aboutus"} style={theme.navbarItem} >About</NavLink>
                                                </NavItem>
                                        }
                                        {
                                            props.isProviderlistPage ? null :
                                                <NavItem>
                                                    <a id="provider-list-nav-item" className='nav-link' href="/counsellors" style={theme.navbarItem} >Counsellors</a>
                                                </NavItem>
                                        }
                                        {
                                            props.isFAQPage ? null :
                                                <NavItem>
                                                    <NavLink id="faq-nav-item" href={NEXT_APP_URL + "/faq"} style={theme.navbarItem} >FAQs</NavLink>
                                                </NavItem>
                                        }
                                        {
                                            props.isContactPage ? null :
                                                <NavItem>
                                                    <NavLink id="contact-us-nav-item" href={NEXT_APP_URL + "/contactus"} style={theme.navbarItem} >Contact</NavLink>
                                                </NavItem>
                                        }
                                        {
                                            user.selectedRole === 'admin' ?
                                                <NavItem>
                                                    <NavLink className="btn px-3" style={theme.generalNavButton} href="/admin/dashboard">Admin Panel</NavLink>
                                                </NavItem>
                                                : null
                                        }
                                        {
                                            user.selectedRole === '' ?
                                                <NavItem>
                                                    <NavLink className="btn px-3" style={theme.generalNavButton} href="/user/landingscreen">Dashboard</NavLink>
                                                </NavItem>
                                                : null
                                        }
                                    </Nav>
                                </Collapse>
                            </Navbar>
                        </div>
            :
            <div>
                {maintenance.status ? <div className="alert alert-primary marquee" style={{ margin: "0 -15px" }}><div>Umang Wellness is going to conduct maintenace to improve your experience. It will go under maintenance on {moment(maintenance.startAt).format("DD-MM-YYYY [at] hh:mm A")} for {maintenance.duration} minutes. During these time you won't be able to use Umang Wellness.</div></div> : null}
                <Navbar id="general-navbar" color="white" light expand="md" style={{ fontFamily: fontFamily.primary, padding: '0.5rem 0' }}>
                    <NavbarBrand id="brand-logo" href={NEXT_APP_URL}>
                        <img style={{ maxWidth: "160px", height: "auto", border: "none", margin: "0" }} src={Logo} alt="Umang Logo" />
                    </NavbarBrand>
                    <NavbarToggler onClick={toggle} />
                    <Collapse isOpen={isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            {
                                props.isDemoPage ? null :
                                    <NavItem>
                                        <NavLink id="demo-login-nav-item" href="/demo/signin" style={theme.navbarItem} >Demo </NavLink>
                                    </NavItem>
                            }
                            {
                                props.isAboutPage ? null :
                                    <NavItem>
                                        <NavLink id="about-nav-item" href={NEXT_APP_URL + "/aboutus"} style={theme.navbarItem} >About</NavLink>
                                    </NavItem>
                            }
                            {
                                props.isProviderlistPage ? null :
                                    <NavItem>
                                        <a id="provider-list-nav-item" className='nav-link' href="/counsellors" style={theme.navbarItem} >Counsellors</a>
                                    </NavItem>
                            }
                            {
                                props.isFAQPage ? null :
                                    <NavItem>
                                        <NavLink id="faq-nav-item" href={NEXT_APP_URL + "/faq"} style={theme.navbarItem} >FAQs</NavLink>
                                    </NavItem>
                            }
                            {
                                props.isContactPage ? null :
                                    <NavItem>
                                        <NavLink id="contact-us-nav-item" href={NEXT_APP_URL + "/contactus"} style={theme.navbarItem} >Contact</NavLink>
                                    </NavItem>
                            }
                            {
                                props.isSignInPage ? null :
                                    <NavItem>
                                        <NavLink id="login-btn" className="btn px-3" style={theme.newGeneralNavButton} href="/user/signin">Sign In</NavLink>
                                    </NavItem>
                            }
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
  )
}

export default GeneralNavbar